import React, { useEffect, useState } from 'react';
import {
  PaymentRequestButtonElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import { PaymentRequest } from '@stripe/stripe-js';
import { observer } from 'mobx-react-lite';
import { useMst } from '../../../models/stores/Root';
import {
  handlePaymentMethod,
  handleShippingAddressChange,
  handleShippingOptionChange,
} from './logic';
import WindowService from '../../../services/WindowService';

// This component is coupled to WrappedStripePaymentRequestButton, do not use it by itself
const StripePaymentRequestButton: React.FC = observer(() => {
  const rootStore = useMst();
  const { cart } = rootStore;
  const stripe = useStripe();
  const elements = useElements();

  if (elements && stripe) {
    rootStore.setStripeElements(stripe, elements);
  }
  const [paymentRequest, setPaymentRequest] = useState<PaymentRequest | null>(
    null
  );

  useEffect(() => {
    if (stripe) {
      const pr = stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'Estimated Total',
          amount: Math.round(cart.grandTotal * 100),
        },
        requestPayerName: true,
        requestPayerEmail: true,
        requestShipping: true,
        requestPayerPhone: true,
      });
      pr.canMakePayment().then(result => {
        if (result && !paymentRequest) {
          setPaymentRequest(pr);
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart.grandTotal, stripe]);

  paymentRequest?.on('paymentmethod', async event => {
    try {
      await handlePaymentMethod(event, rootStore);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      event.complete('fail');
      return;
    }
    const intentId =
      cart.stripeInfo.paymentIntentId ?? cart.stripeInfo.setupIntentId;

    if (!intentId) {
      event.complete('fail');
      return;
    }
    event.complete('success');

    // current state management classes with form hooks, this prevents a complete refactor of one or the other
    WindowService.navigate(
      `?token=${intentId}&tokenProvider=STRIPE&walletType=${event.paymentMethod.card?.wallet?.type}`
    );
  });

  paymentRequest?.on('shippingaddresschange', async event => {
    await handleShippingAddressChange(event, cart);
  });

  paymentRequest?.on('shippingoptionchange', async event => {
    await handleShippingOptionChange(event, cart);
  });

  return paymentRequest ? (
    <span style={{ width: '100%', maxWidth: '250px' }}>
      <PaymentRequestButtonElement
        options={{
          paymentRequest,
        }}
      />
    </span>
  ) : null;
});

export default StripePaymentRequestButton;
